//引入crypto-js
const CryptoJS = require("crypto-js");
// 加密
function encryptDES(message, key) {
  var keyHex = CryptoJS.enc.Utf8.parse(key);
  var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
    iv: CryptoJS.enc.Utf8.parse(key),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  var result = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  return result;
}

// 解密
function decryptDES(message, key) {
  var keyHex = CryptoJS.enc.Utf8.parse(key);
  var decrypted = CryptoJS.TripleDES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(message),
    },
    keyHex,
    {
      iv: CryptoJS.enc.Utf8.parse(key),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}


//md5加密

function MD5_JS(str) {
    try {
        // Convert the string to lowercase and get its byte array
        const emailBytes = CryptoJS.enc.Utf8.parse(str.toLowerCase());

        // Calculate MD5 hash
        const hashedEmailBytes = CryptoJS.MD5(emailBytes);

        // Convert byte array to hexadecimal string
        const hashedEmailHex = hashedEmailBytes.toString(CryptoJS.enc.Hex);

        return hashedEmailHex;
    } catch (error) {
        console.error(error);
        return null;
    }
}




export { encryptDES, decryptDES , MD5_JS };
